import { useContainer } from '@hub-la/fe-container';
import { HttpClient } from '@hub-la/fe-core-http-client';
import { useQuery } from 'react-query';
import { GetSections } from '../../usecases/get-sections.js';

const useGetSections = (input, isBeta = false) => {
  const container = useContainer();
  return useQuery('get-sections', () => new GetSections(container.get(HttpClient)).execute(input, isBeta), {
    retryOnMount: false,
    refetchOnWindowFocus: false,
    initialData: [],
    retry: false,
    enabled: !!input.productId
  });
};

export { useGetSections };
